module.exports = __webpack_public_path__ + "static/media/peace.82bffe5a.svg";